export const timeFilterEnum = {
  ALL: 'ALL',
  DAILY: 'DAILY',
  MINUTE_30: 'MINUTE_30',
  HOURLY: 'HOURLY',
} as const

export type TimeFilterEnum = (typeof timeFilterEnum)[keyof typeof timeFilterEnum]

export type TimeFilter = TimeFilterEnum